import React, { ReactElement } from "react";
import { Profile as ProfilePage } from "@widgets/profile";
import {PageMeta} from "@shared/seo/page-meta";

export const Profile: React.FC = (): ReactElement => {
    return (
        <>
            <PageMeta
                title="Вас приглашают в Plumme"
                description="Plumme объединяет людей через закрытые клубы, события и сообщества по интересам в Москве и других городах России."
                path="/profile"
                noIndex
            />
            <ProfilePage />
        </>

    );
};